import { render } from "./HeroiconsOutlineXCircle.vue?vue&type=template&id=7bdca590"
const script = {}

import exportComponent from "/Users/taylor/Documents/Code/laravel-nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineXCircle.vue"]])

export default __exports__